import React, { useState, useEffect } from 'react';
import { LiveChat } from './LiveChat';
import { AIChatWidget } from './AIChatWidget';

// This component manages which chat agent to show based on admin settings
export const ChatAgentSelector = () => {
  const [selectedAgent, setSelectedAgent] = useState('apollo_assistant'); // Default to Apollo Assistant

  useEffect(() => {
    // Load saved preference from localStorage
    const savedAgent = localStorage.getItem('preferred_chat_agent');
    if (savedAgent) {
      setSelectedAgent(savedAgent);
    }
  }, []);

  // Listen for changes from admin settings
  useEffect(() => {
    const handleAgentChange = (event) => {
      if (event.detail && event.detail.agent) {
        setSelectedAgent(event.detail.agent);
        localStorage.setItem('preferred_chat_agent', event.detail.agent);
      }
    };

    window.addEventListener('chatAgentChanged', handleAgentChange);
    return () => window.removeEventListener('chatAgentChanged', handleAgentChange);
  }, []);

  // Render the selected chat agent
  if (selectedAgent === 'ai_support') {
    return <AIChatWidget defaultAssistant="customer_support" />;
  }

  // Default: Apollo Assistant (LiveChat)
  return <LiveChat />;
};

export default ChatAgentSelector;
